import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const steps = [
  {
    num: '1',
    title: 'Check Your System',
    description: 'Check your system or estimate replacement cost using our free online tools.',
  },
  {
    num: '2',
    title: 'Compare Contractors',
    description: 'Compare trusted HVAC contractors serving your area.',
  },
  {
    num: '3',
    title: 'Choose the Best Option',
    description: 'Choose the best option for your home — no pressure, no obligation.',
  },
];

const HowItWorks = () => {
  return (
    <section className="py-16 bg-white" data-testid="how-it-works-section">
      <div className="max-w-5xl mx-auto px-6">
        <h2
          className="text-3xl md:text-4xl font-bold text-center text-[#0F172A] mb-3"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          How NOLA HVAC Connect Works
        </h2>
        <p className="text-center text-slate-500 mb-12 max-w-xl mx-auto">
          Three simple steps to smarter HVAC decisions.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mb-10">
          {steps.map((step, i) => (
            <div key={i} className="text-center" data-testid={`how-it-works-step-${i}`}>
              <div className="w-14 h-14 bg-[#0EA5E9] text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {step.num}
              </div>
              <h3
                className="text-lg font-bold text-[#0F172A] mb-2"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {step.title}
              </h3>
              <p className="text-slate-500 text-sm">{step.description}</p>

              {i < steps.length - 1 && (
                <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2">
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <a href="/instant-hvac-estimate-new-orleans">
            <Button
              className="bg-[#F97316] hover:bg-[#EA580C] text-white font-bold py-3 px-8 rounded-full text-lg"
              data-testid="how-it-works-cta"
            >
              Start My Estimate
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
